import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import makeGetUnshippableGroupSelector
from '../../../v2/selectors/DeliveryOptionsSelectors/makeGetUnshippableGroupSelector';
import {getSiteCode} from '../../../v2/selectors/selectors';
import Spacing from '../../../v2/style-helper/Spacing';
import DeliveryOptionProductList from '../DeliveryOptionProductList/DeliveryOptionProductList';
import {
  isOptionalGroupUsed,
} from '../../../v2/selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import BasketItemsProptype from '../../../propTypes/BasketItems.proptype';

const useStyles = createUseStyles({
  deliveryOptionProductListContainer: {
    margin: Spacing.triple,
    listStyle: 'none',
  },
});

export function DeliveryOptionProductListContainer(props) {
  const classes = useStyles();
  
  const getFilteredItems = () => {
    if (props.isFastTrackGroup) {
      return props.basketItems.filter(item => item.fastDelivery);
    }
    if (props.isToggleOn) {
      return props.basketItems.filter(item => !item.fastDelivery);
    }
    if (props.unshippableBasketItems && props.unshippableReason) {
      // Split insufficient_stock groups
      if (props.unshippableReason === 'insufficient_stock') {
        return [props.unshippableBasketItems.find(basketItem => basketItem.id === props.basketItems?.[0].id)];
      }
      return props.unshippableBasketItems;
    }
    // Supporting old flow - now deprecated
    if (props.unshippableReason === 'unshippableItems') {
      return props.basketItems.filter(item => !item.shippable);
    }
    return props.basketItems.filter(item => item.shippable);
  };
  
  return (
    <ul className={classes.deliveryOptionProductListContainer} data-test="DeliveryOptionProductListContainer">
      {getFilteredItems().map((item, index) => (
        <DeliveryOptionProductList
          key={index}
          item={item}
          index={index}
          isRectangle={props.isRectangle}
        />
      ))}
    </ul>
  );
}

const mapStateToProps = (state, ownProps) => {
  const getUnshippableGroup = makeGetUnshippableGroupSelector(ownProps.unshippableReason);
    
  return {
    unshippableBasketItems: ownProps.unshippableReason ? getUnshippableGroup(state).basketItems : [],
    isToggleOn: isOptionalGroupUsed(state),
    isRectangle: getSiteCode(state) === 'matalan',
  };
};

DeliveryOptionProductListContainer.propTypes = {
  isFastTrackGroup: PropTypes.bool.isRequired,
  isRectangle: PropTypes.bool,
  isToggleOn: PropTypes.bool.isRequired,
  unshippableReason: PropTypes.string.isRequired,
  unshippableBasketItems: PropTypes.arrayOf(PropTypes.shape(BasketItemsProptype)),
  basketItems: PropTypes.arrayOf(PropTypes.shape(BasketItemsProptype)).isRequired,
};

export default connect(mapStateToProps)(DeliveryOptionProductListContainer);
